<template>
	<div class="xs-12 p3 bb1 bc7" v-if="computedPriceBreakdown.length > 0">
		<div slot="header" class="xs-12 fs3 lh125 fw7 pb2">
			{{ $t("price_breakdown") }}
		</div>
		<div slot="body">
			<j-list :list="computedPriceBreakdown" :itemClasses="'mb2 bg4 r2'">
				<div class="flex xs-12 p3" slot="list" slot-scope="{ item }">
					<div class="flex wrap  xs-6 xs-left xs-middle">
						<div class="xs-12 fw7 c6 lh125">{{ item.label }}</div>
						<div class="xs-12 c6 lh125">
							{{ $t("order") }}: {{ item.order }}
						</div>
					</div>
					<div class="xs-6 ta3">
						<div class="lh125">{{ item.value }}</div>
						<div class="c6 lh125">{{ item.summary }}</div>
					</div>
				</div>
			</j-list>
		</div>
	</div>
</template>

<script>
import get from "lodash.get"
import JList from "@/components/JList"

export default {
	components: {
		JList
	},
	props: {
		pricing: {
			type: Object
		}
	},
	computed: {
		computedPriceBreakdown() {
			// Combine taxes and discounts together and order based on order
			const appliedDiscounts = this.pricing.appliedDiscounts
				? this.pricing.appliedDiscounts
				: []
			const appliedTaxes = this.pricing.appliedTaxes
				? this.pricing.appliedTaxes
				: []

			const taxesAndDiscounts = [...appliedDiscounts, ...appliedTaxes].sort(
				(a, b) => a.order - b.order
			)

			const getValue = item => {
				if (!item) return ""
				const ratio = item.ratio ? item.ratio * 100 : null
				const flat = item.formattedFlat ? item.formattedFlat : "0"
				return {
					flat,
					summary: ratio
						? `(${ratio ? ratio.toFixed(2) : "0"}% of ${
								item.formattedOriginalPrice
						  })`
						: ""
				}
			}

			const loadings = get(this, "pricing.loadings", []) || []

			// prettier-ignore
			return [
				...loadings.map(loading => ({
					label: `${get(loading, "codeName.name", "")}`,
					value: `${get(this, "pricing.currencyCode", "") || ""}${loading?.flat?.toFixed(2)
							.replace(/\d(?=(\d{3})+\.)/g, "$&,") || "0"}`,
					summary: `(${loading.ratio ? loading.ratio?.toFixed(2) * 100 : null || "0"}% of ${this.pricing.formattedOriginalPrice})`,
					order: loading.order
				})),
				...taxesAndDiscounts.map(item => ({
					label: item.name ? item.name : item.code,
					value: getValue(item).flat,
					summary: getValue(item).summary,
					order: item.order

				}))
			]
		}
	}
}
</script>

<style></style>
